import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { Breadcrumb } from "react-bootstrap";
import * as Yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./PremiseAction.css";
import Switch from "react-switch";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import FileUploadImage from "../../assets/upload.png";
import { Country, State, City } from "country-state-city";
import { encryptData } from "../Common/encryptionUtils";
import { apiRequest } from "../../services/api";
import { useNavigate } from "react-router-dom";
import Loader from "../Common/Loader";
import {
  Form,
  Button,
  Card,
  Dropdown,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import { FaTimes } from "react-icons/fa";
import dateFormatFetchByCountry from "../../Utils/country-date-formats.json";
import phoneCodeFetchByCountry from "../../Utils/country-phone-code.json";
import { AccessLog } from "../../Utils/AccessLog";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  List,
  ListItem,
  Paper,
} from "@mui/material";
import { useJsApiLoader } from "@react-google-maps/api";

import tzlookup from "tz-lookup";
// import 'react-clock/dist/Clock.css';

const StepProgress = ({ currentStep }) => {
  const steps = ["Premises Information", "Address", "General"];

  return (
    <div className="mb-4 position-relative">
      {/* Steps */}
      <div className="d-flex justify-content-between stepBarDiv position-relative w-100">
        {steps.map((step, index) => (
          <div
            key={`step-${index}`}
            className="text-center stepBar"
            style={{ flex: 1, position: "relative" }}
          >
            <div
              className={`step-circle ${
                index <= currentStep ? "completed" : ""
              }`}
              style={{
                width: "30px", // Circle size
                height: "30px", // Circle size
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 auto", // Center the circle
                border: "2px solid",
                borderColor: index <= currentStep ? "#007bff" : "#dcdcdc",
                backgroundColor:
                  index <= currentStep ? "#007bff" : "transparent",
                color: index <= currentStep ? "#fff" : "#dcdcdc",
              }}
            >
              {index <= currentStep ? "✔" : ""}
            </div>
            <span
              className={`mt-2 d-block stepTitle ${
                index <= currentStep ? "text-primary" : "text-muted"
              }`}
              style={{ fontSize: "12px" }}
            >
              {step}
            </span>
          </div>
        ))}
      </div>

      {/* Progress Bar Segments */}
      <div
        className="stepBarLine"
        style={{
          position: "absolute",
          top: "13px", // Position the bars below the steps
          left: 0,
          right: 0,
        }}
      >
        <div className="d-flex justify-content-between align-items-center w-100 stepbarwidth">
          {steps.slice(0, -1).map((_, index) => (
            <div
              key={`bar-${index}`}
              className={`bar-${index}`}
              style={{
                flex: 1,
                height: "2px",
                backgroundColor: index < currentStep ? "#007bff" : "#dcdcdc",
                margin: "0 10px", // Space between bars
                borderRadius: "4px",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const PremiseStepOne = ({ onNext, setDefaultAddress }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const premiseData = location.state?.premise || {};
  const [imagePreview, setImagePreview] = useState(
    JSON.parse(localStorage.getItem("stepOneData"))?.photo || premiseData?.photo
  );

  const handleBackButton = () => {
    navigate("/premises");
  };

  const [openTime, setOpenTime] = useState("09:30");
  const [closeTime, setCloseTime] = useState("19:00");

  // Initial values from localStorage or default
  const initialValues = {
    photo: JSON.parse(localStorage.getItem("stepOneData"))?.photo || "",
    title: JSON.parse(localStorage.getItem("stepOneData"))?.title || "showroom",
    name: JSON.parse(localStorage.getItem("stepOneData"))?.name || "",
    openTime:
      JSON.parse(localStorage.getItem("stepOneData"))?.openTime || openTime,
    closeTime:
      JSON.parse(localStorage.getItem("stepOneData"))?.closeTime || closeTime,
    gstNo: JSON.parse(localStorage.getItem("stepOneData"))?.gstNo || "",
  };

  // Validation schema
  const createStepOneValidationSchema = Yup.object({
    // photo: Yup.string().required("Premises image is required."),
    title: Yup.string().required("Type is required."),
    name: Yup.string()
      .trim()
      .min(3, "Premises name must be at least 3 characters long.")
      .matches(/[a-zA-Z]/, "Premises name must contain at least one letter.")
      .required("Premises name is required.")
      .test(
        "unique-premises-name",
        "This premises name is already taken. Please try a different one.",
        function (value) {
          return !isDuplicatePremisesName(value);
        }
      ),
    gstNo: Yup.string()
      .trim()
      .matches(
        // GST (India), EIN (US), VAT (EU), TRN (UAE) – simplified patterns
        /(^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$)|(^\d{2}-\d{7}$)|(^[A-Z0-9]{8,15}$)/,
        "Invalid Business Tax ID format"
      ),
  });

  const premisesList = JSON.parse(localStorage.getItem("PremisesList")) || [];
  const isDuplicatePremisesName = (name) => {
    return premisesList.some(
      (premises) => premises.name.toLowerCase() === name.toLowerCase()
    );
  };
  const premisesListDetails = premisesList.filter(
    (premises) => premises.name !== initialValues.name
  );
  const isDuplicateUpdatePremisesName = (name) => {
    return premisesListDetails.some(
      (premises) => premises.name.toLowerCase() === name.toLowerCase()
    );
  };

  const updateStepOneValidationSchema = Yup.object({
    title: Yup.string().required("Type is required."),
    name: Yup.string()
      .trim()
      .min(3, "Premises name must be at least 3 characters long.")
      .matches(/[a-zA-Z]/, "Premises name must contain at least one letter.")
      .required("Premises name is required.")
      .test(
        "unique-premises-name",
        "This premises name is already taken. Please try a different one.",
        function (value) {
          return !isDuplicateUpdatePremisesName(value);
        }
      ),
    gstNo: Yup.string()
      .trim()
      .matches(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        "Invalid GST Number format"
      ),
  });

  // Save form data to localStorage
  const saveToLocalStorage = (key, value) => {
    console.log("locationpathname--->", location.pathname);
    if (location.pathname === "/premise/create") {
      if (key === "name") {
        setDefaultAddress(value);
      }
    }

    const currentData = JSON.parse(localStorage.getItem("stepOneData")) || {};
    currentData[key] = value;
    localStorage.setItem("stepOneData", JSON.stringify(currentData));
  };

  // Handle image upload and preview
  const handleImageUpload = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        toast.info("File size exceeds 2 MB. Please upload a smaller file.");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFieldValue("photo", reader.result);
        saveToLocalStorage("photo", reader.result); // Save base64 image in localStorage
      };
      reader.readAsDataURL(file);
    }
  };

  // useEffect(() => {
  //   const savedData = JSON.parse(localStorage.getItem("stepThreeData")) || {};
  //   if (savedData.openTime) setOpenTime(savedData.openTime);
  //   if (savedData.closeTime) setCloseTime(savedData.closeTime);

  //   if (!savedData.openTime) {
  //     const updatedTimes = {
  //       openTime: "09:30",
  //       closeTime: "19:00",
  //     };
  //     const newData = { ...savedData, ...updatedTimes };
  //     localStorage.setItem("stepThreeData", JSON.stringify(newData));
  //   }
  // }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={
        premiseData?.name
          ? updateStepOneValidationSchema
          : createStepOneValidationSchema
      }
      onSubmit={(values) => {
        onNext(values); // Pass validated form values to the next step
        const currentData =
          JSON.parse(localStorage.getItem("stepOneData")) || {};

        // Only set 'title' if it doesn't already exist
        if (!currentData.hasOwnProperty("title")) {
          currentData.title = "showroom";
          localStorage.setItem("stepOneData", JSON.stringify(currentData));
        }
        if (currentData.openTime) setOpenTime(currentData.openTime);
        if (currentData.closeTime) setCloseTime(currentData.closeTime);
        if (!currentData.openTime) {
          const updatedTimes = {
            openTime: "09:30",
            closeTime: "19:00",
          };
          const newData = { ...currentData, ...updatedTimes };
          localStorage.setItem("stepOneData", JSON.stringify(newData));
        }

        const stepTwoData =
          JSON.parse(localStorage.getItem("stepTwoData")) || {};
        if (!stepTwoData.hasOwnProperty("address1")) {
          stepTwoData.address1 = values?.name;
          localStorage.setItem("stepTwoData", JSON.stringify(stepTwoData));
        } else if (stepTwoData?.address1 === "") {
          stepTwoData.address1 = values?.name;
          localStorage.setItem("stepTwoData", JSON.stringify(stepTwoData));
        }
      }}
    >
      {({ handleSubmit, setFieldValue }) => (
        <Card
          className="p-4 premiseDetailsSubDiv PremiseActionFirstForm"
          style={{
            borderRadius: "10px",
            border: "none",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
          }}
        >
          <Card.Body>
            <div className="row" style={{ marginTop: "-20px" }}>
              <div className="col-6">
                <i
                  className="fa fa-long-arrow-left backIcon premiseBackIcon"
                  aria-hidden="true"
                  onClick={handleBackButton}
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
            </div>
            {/* <h4 className="text-primary text-center policyFormTitle premiseFormTitle PremiseDetailsMainDiv">
              Premises Information
            </h4> */}

            <div className="row userInformationDiv premiseInformationDiv">
              <div className="col-md-3 col-4 premiseInfoMainDiv">
                <div className="p-3 border rounded shadow-sm bg-light userInformationDetails premiseInfoDetails">
                  <h6
                    className="fw-bold text-primary"
                    style={{ fontSize: "15px" }}
                  >
                    Premises Information
                  </h6>
                  <p
                    className=" mb-0"
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "rgb(170, 170, 170)",
                    }}
                  >
                    Enter the premises information
                  </p>
                </div>
                <div
                  className="mt-2 PremiseImageLabelDiv"
                  style={{ marginBottom: "-30px" }}
                >
                  <label htmlFor="timeField" className=" time-label"></label>
                </div>
                <div className="col-md-12 PremiseImageMainDiv userImageMainDiv PremiseImagesDiv">
                  <label htmlFor="fileInput" className="file-label">
                    <input
                      type="file"
                      id="fileInput"
                      className="file-input"
                      accept="image/*"
                      onChange={(e) => handleImageUpload(e, setFieldValue)}
                    />
                    <div className="premiseImageRoundDiv">
                      <div className="file-box">
                        {imagePreview ? (
                          <img
                            src={imagePreview}
                            alt="Preview"
                            className="image-preview"
                          />
                        ) : (
                          <>
                            <span className="text-image">
                              <img
                                src={FileUploadImage}
                                className="ImageUpload"
                                alt="Upload Icon"
                              />
                            </span>
                            <h1 className="upload-heading">Upload Image</h1>
                            <p className="image-instruction">
                              Image size must be less than 2 MB
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="chooseFileDiv">
                      <span className="btn btn-primary mt-2 chooseFileBtn">
                        Choose Image
                      </span>
                    </div>
                    <h6 className="user-label">Premises Image</h6>
                  </label>
                </div>
              </div>

              <div className="col-md-9 col-8 premiseInfoDiv">
                <Form
                  noValidate
                  onSubmit={handleSubmit}
                  className="userCreateForm premiseCreationForms"
                  autoComplete="OFF"
                >
                  {/* Name Field */}
                  <div className="col-md-12 " style={{ marginBottom: "18px" }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <label
                        htmlFor="name"
                        className="bluetooth-label label-switch mb-0 userFormlabel PremiseNameLabel"
                      >
                        Premises Name <span className="text-danger">*</span>
                      </label>

                      <div
                        style={{ width: "250px" }}
                        className="PremiseInputFieldDiv premiseInputDiv"
                      >
                        <Field
                          type="text"
                          name="name"
                          id="name"
                          className="form-input"
                          placeholder=" "
                          autoComplete="off"
                          autoFocus
                          onChange={(e) => {
                            // const sanitizedValue = e.target.value.replace(
                            //   /[^A-Za-z\s]/g,
                            //   ""
                            // );
                            setFieldValue("name", e.target.value);
                            saveToLocalStorage("name", e.target.value);
                          }}
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-danger policy-error mb-0 mt-1"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Title Field */}
                  <div className="col-md-12 " style={{ marginBottom: "20px" }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <label
                        htmlFor="name"
                        className="bluetooth-label label-switch mb-0 userFormlabel"
                      >
                        Type <span className="text-danger">*</span>
                      </label>

                      <div
                        style={{ width: "250px" }}
                        className="PremiseInputFieldDiv premiseInputDiv"
                      >
                        <Field
                          as="select"
                          name="title"
                          id="title"
                          className="form-input"
                          autoComplete="off"
                          onChange={(e) => {
                            setFieldValue("title", e.target.value);
                            saveToLocalStorage("title", e.target.value);
                          }}
                        >
                          <option value="" selected disabled>
                            Select Type
                          </option>
                          <option
                            value="showroom"
                            selected={initialValues.title === "showroom"}
                          >
                            Showroom
                          </option>
                          <option value="office">Office</option>
                          <option value="shop">Shop</option>
                        </Field>

                        <ErrorMessage
                          name="title"
                          component="div"
                          className="text-danger policy-name-error premise-name-error policy-error mt-1 mb-0"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 " style={{ marginBottom: "20px" }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <label
                        htmlFor="name"
                        className="bluetooth-label label-switch mb-0 userFormlabel"
                      >
                        Open Time <span className="text-danger">*</span>
                      </label>

                      <div
                        style={{ width: "250px" }}
                        className="PremiseInputFieldDiv premiseInputDiv"
                      >
                        <Field
                          type="time"
                          id="openTime"
                          name="openTime"
                          onChange={(e) => {
                            setFieldValue("openTime", e.target.value);
                            setOpenTime(e.target.value);
                            saveToLocalStorage("openTime", e.target.value);
                          }}
                          className="form-input styled-time-input"
                        />
                        <ErrorMessage
                          name="openTime"
                          component="div"
                          className="text-danger register-error"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 " style={{ marginBottom: "18px" }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <label
                        htmlFor="name"
                        className="bluetooth-label label-switch mb-0 userFormlabel"
                      >
                        Close Time <span className="text-danger">*</span>
                      </label>

                      <div
                        style={{ width: "250px" }}
                        className="PremiseInputFieldDiv premiseInputDiv"
                      >
                        <Field
                          type="time"
                          id="closeTime"
                          name="closeTime"
                          onChange={(e) => {
                            setFieldValue("closeTime", e.target.value);
                            setCloseTime(e.target.value);
                            saveToLocalStorage("closeTime", e.target.value);
                          }}
                          className="form-input styled-time-input"
                        />
                        <ErrorMessage
                          name="closeTime"
                          component="div"
                          className="text-danger register-error"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12" style={{ marginBottom: "18px" }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <label
                        htmlFor="gstNo"
                        className="bluetooth-label label-switch mb-0 userFormlabel TaxId"
                      >
                        Business Tax ID (EIN/GST/TRN/VAT)
                      </label>

                      <div
                        style={{ width: "250px" }}
                        className="PremiseInputFieldDiv premiseInputDiv"
                      >
                        <Field
                          type="text"
                          id="gstNo"
                          name="gstNo"
                          onChange={(e) => {
                            const upperValue = e.target.value.toUpperCase();
                            setFieldValue("gstNo", e.target.value);
                            saveToLocalStorage("gstNo", e.target.value);
                          }}
                          placeholder="Enter the Business Tax ID"
                          className="form-input"
                        />
                        <ErrorMessage
                          name="gstNo"
                          component="div"
                          className="text-danger policy-error mb-0 mt-1"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className="d-flex justify-content-end PremiseActionBtn"
                    style={{
                      marginBottom: "0px",
                      marginTop: "60px",
                    }}
                  >
                    <Button
                      className="previousBtn premiseNextBtn"
                      type="submit"
                      variant="primary"
                    >
                      Next
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Card.Body>
        </Card>
      )}
    </Formik>
  );
};

const PremiseStepTwo = ({
  onPrevious,
  onNext,
  timeZoneDetails,
  defaultAddress,
  setDefaultAddress,
}) => {
  console.log("defaultAddress-->", defaultAddress);
  const location = useLocation();
  const premiseData = location.state?.premise;
  const [imagePreview, setImagePreview] = useState(premiseData?.photo || null);

  const GOOGLE_MAPS_API_KEY = "AIzaSyAfl3Oh-uGgHqYEydcp4xcaBE5s3H_xSTo"; // Replace with your actual API key

  const libraries = ["places"];

  const [placeData, setPlaceData] = useState(() => {
    const savedData = localStorage.getItem("stepTwoData");
    return savedData
      ? JSON.parse(savedData)
      : {
          address1: "",
          address2: "",
          city: "",
          state: "",
          country: "",
        };
  });

  const validationSchema = Yup.object({
    // address1: Yup.string().trim().required("Address Line 1 is required."),
    // country: Yup.string().required("Country is required."),
    // state: Yup.string().required("State is required."),
    // city: Yup.string().required("City is required."),
  });

  console.log("placeData-->", placeData);

  // Initialize form fields with data from localStorage if available
  const initialValues = {
    address1: JSON.parse(localStorage.getItem("stepTwoData"))?.address1 || "",
    address2: JSON.parse(localStorage.getItem("stepTwoData"))?.address2 || "",
    country: JSON.parse(localStorage.getItem("stepTwoData"))?.country || "",
    state: JSON.parse(localStorage.getItem("stepTwoData"))?.state || "",
    city: JSON.parse(localStorage.getItem("stepTwoData"))?.city || "",
  };

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);
  const [timezones, setTimezones] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [inputValue, setInputValue] = useState(defaultAddress || "");
  console.log("inputValue--->", inputValue);
  const saveToLocalStorage = (key, value) => {
    const currentData = JSON.parse(localStorage.getItem("stepTwoData")) || {};
    currentData[key] = value;
    localStorage.setItem("stepTwoData", JSON.stringify(currentData));
  };

  useEffect(() => {
    // Load all countries
    const allCountries = Country.getAllCountries();
    setCountries(allCountries);

    // Get form data from localStorage when the component mounts
    const formData = JSON.parse(localStorage.getItem("stepTwoData"));
    if (formData) {
      initialValues.address1 = formData.address1;
      initialValues.address2 = formData.address2;
      initialValues.country = formData.country;
      initialValues.state = formData.state;
      initialValues.city = formData.city;
      setSelectedCountry(formData.country);
      setSelectedState(formData.state);
    }
  }, []);

  useEffect(() => {
    // Fetch states when the country changes
    const formData = JSON.parse(localStorage.getItem("stepTwoData") || "{}");

    if (formData?.country?.trim()) {
      console.log("Data Value-->", formData?.country);
      const country = countries.find((c) => c.name === formData?.country);
      console.log("countries-->", countries);
      if (country) {
        setSelectedCountryId(country?.isoCode);
        const statesByCountry = State.getStatesOfCountry(country.isoCode);
        setStates(statesByCountry);
      }
    }
  }, [selectedCountry, countries]);

  // useEffect(() => {
  //   // Fetch cities when the state changes
  //   if (selectedState && selectedCountry) {
  //     const state = states.find((s) => s.name === selectedState);
  //     if (state) {
  //       const citiesByState = City.getCitiesOfState(
  //         selectedCountryId,
  //         state.isoCode
  //       );
  //       if (citiesByState.length) {
  //         setCities(citiesByState);
  //       } else {
  //         setCities([]); // In case no cities are found
  //       }
  //     }
  //   }
  // }, [selectedState, selectedCountry, states]);

  const handleCountryChange = (e) => {
    const countryName = e.target.value;
    setSelectedCountry(countryName);
    saveToLocalStorage("country", countryName);

    // Clear state and city when country is changed
    setSelectedState("");
    setCities([]);
  };

  const handleStateChange = (e) => {
    const stateName = e.target.value;
    setSelectedState(stateName);
    saveToLocalStorage("state", stateName);
  };

  const [showErrors, setShowErrors] = useState(false);

  const onNexts = (values) => {
    setShowErrors(true);
    // saveToLocalStorage("address1", values.address1);
    // saveToLocalStorage("address2", values.address2);
    // saveToLocalStorage("country", values.country);
    // saveToLocalStorage("state", values.state);
    // saveToLocalStorage("city", values.city);
    const formData = JSON.parse(localStorage.getItem("stepTwoData") || "{}");

    if (
      formData?.address1?.trim() &&
      formData?.country?.trim() &&
      formData?.state?.trim()
    ) {
      onNext();
    }

    const country = countries.find((c) => c.name === values.country);
    console.log("FormData-->", values);
  };

  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nextPageToken, setNextPageToken] = useState(null);
  const debounceTimer = useRef(null);
  const dropdownRef = useRef(null);

  const [locationData, setLocationData] = useState({ lat: null, lon: null });
  console.log("locationData--->", locationData);
  const fetchLatLng = async (state) => {
    setLocationData({ lat: null, lon: null });

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?state=${state}&format=json`
      );
      const data = await response.json();

      if (data && data.length > 0) {
        setLocationData({ lat: data[0].lat, lon: data[0].lon });
        const currentData =
          JSON.parse(localStorage.getItem("stepTwoData")) || {};

        const timezoneValue = tzlookup(data[0].lat, data[0].lon);

        currentData.timezone = timezoneValue;
        localStorage.setItem("stepTwoData", JSON.stringify(currentData));
      } else {
      }
    } catch (err) {}
  };

  const fetchSuggestions = async (query, pageToken = null, append = false) => {
    if (!query) return;
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = { Authorization: `Bearer ${authToken}` };

      const url = `web_api/admin/search-places?query=${encodeURIComponent(
        query
      )}${pageToken ? `&page_token=${pageToken}` : ""}`;

      const response = await apiRequest(url, "GET", null, headers);

      const results = response.data.results || [];
      const newToken = response.data.next_page_token;

      setSuggestions((prev) => (append ? [...prev, ...results] : results));
      setNextPageToken(newToken || null);
      setShowDropdown(true);
    } catch (err) {
      console.error("Error fetching places:", err);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    console.log("EValue--->", e);
    const value = e.target.value;
    setInputValue(value);
    setShowDropdown(false);
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    if (!value) {
      setSuggestions([]);
      return;
    }

    debounceTimer.current = setTimeout(() => {
      fetchSuggestions(value);
    }, 300);
  };

  const handleSelect = (item) => {
    // setInputValue(
    //   item.name || item.description || item.formatted_address || ""
    // );
    setSuggestions([]);
    setShowDropdown(false);
    getPlaceDetails(item?.place_id);
    console.log("Selected:", item);
  };

  const handleLoadMore = () => {
    if (nextPageToken) {
      fetchSuggestions(inputValue, nextPageToken, true);
    }
  };

  // Optional: Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getPlaceDetails = async (placeId) => {
    const placesService = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    placesService.getDetails({ placeId }, async (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        const address = {
          address1: "",
          address2: "",
          city: "",
          state: "",
          country: "",
          phoneCode: "",
          timezone: "",
        };

        const formattedAddress = place.formatted_address || "";
        let city = "";
        let state = "";
        let country = "";
        let locality = "";
        let adminLevel3 = "";

        // Extract city, state, country
        place.address_components.forEach((component) => {
          const types = component.types;
          if (types.includes("locality")) {
            locality = component.long_name;
          }
          if (types.includes("administrative_area_level_3")) {
            adminLevel3 = component.long_name;
          }
          if (types.includes("administrative_area_level_1")) {
            state = component.long_name;
            address.state = component.long_name;
          }
          if (types.includes("country")) {
            country = component.long_name;
            address.country = component.long_name;
          }
        });

        if (
          adminLevel3 &&
          formattedAddress.toLowerCase().includes(adminLevel3.toLowerCase())
        ) {
          city = adminLevel3;
        } else if (
          locality &&
          formattedAddress.toLowerCase().includes(locality.toLowerCase())
        ) {
          city = locality;
        }
        address.city = city;

        function extractAddressParts(
          formattedAddress,
          city = "",
          state = "",
          country = ""
        ) {
          let cleanedAddress = formattedAddress;

          // Remove dynamic city, state, and country
          [city, state, country].forEach((part) => {
            if (part && cleanedAddress.includes(part)) {
              cleanedAddress = cleanedAddress.replace(part, "");
            }
          });

          // Remove ZIP code (any 5-7 digit number)
          cleanedAddress = cleanedAddress.replace(/\d{5,7}/g, "");

          // Clean up extra commas and whitespace
          cleanedAddress = cleanedAddress
            .replace(/,+/g, ",")
            .replace(/,\s*$/, "")
            .trim();

          const parts = cleanedAddress
            .split(",")
            .map((p) => p.trim())
            .filter(Boolean);

          const address1 = parts.slice(0, 3).join(", ");
          const address2 = parts.slice(3).join(", ");

          setInputValue(address1);
          setDefaultAddress(address1);

          return {
            address1,
            address2,
            city,
            state,
            country,
          };
        }

        // Now update your `address` object

        const splitAddress = extractAddressParts(
          formattedAddress,
          city,
          state,
          country
        );

        console.log("splitAddress-->", splitAddress);

        address.address1 = splitAddress.address1;
        address.address2 = splitAddress.address2;

        // 🌐 Get Lat/Lng + Timezone
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        console.log("lat--->", lat);
        console.log("lat1--->", lng);
        const timezone = tzlookup(lat, lng);
        address.timezone = timezone || "N/A";

        const getPhoneCodeByCountry = (country) => {
          return phoneCodeFetchByCountry[country] || "+91"; // Default to '+91' if not found
        };
        // Example usage
        const PhoneCodeValue = getPhoneCodeByCountry(address?.country);

        address.phoneCode = PhoneCodeValue;

        const getDateFormatByCountry = (country) => {
          return dateFormatFetchByCountry[country] || "d-m-Y"; // Default to 'd-m-Y' if not found
        };
        // Example usage
        const DateFormatValue = getDateFormatByCountry(address?.country);

        // Set date format based on country
        address.dateFormat = DateFormatValue;

        console.log("Smart Split Address --->", address);

        localStorage.setItem("stepTwoData", JSON.stringify(address));
        setPlaceData(address);

        const countryData = countries.find((c) => c.name === address?.country);
        console.log("countries-->", countries);
        if (country) {
          setSelectedCountryId(countryData?.isoCode);
          const statesByCountry = State.getStatesOfCountry(countryData.isoCode);
          setStates(statesByCountry);
        }
      }
    });
  };

  // 📝 Handle user typing
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlaceData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  console.log("inputValue--->", inputValue);

  useEffect(() => {
    if (inputValue) {
      const value = { target: { value: inputValue } };
      handleInputChange(value);
      // setShowDropdown(true);
    }
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => onNexts(values)} // Save to localStorage before moving to the next step
    >
      {({ handleSubmit, setFieldValue }) => (
        <Card
          className="p-4 premiseDetailsSubDiv"
          style={{
            borderRadius: "10px",
            border: "none",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
          }}
        >
          <Card.Body className="AddressMainDiv">
            <div className="row" style={{ marginTop: "-20px" }}>
              <div className="col-6">
                <i
                  className="fa fa-long-arrow-left backIcon"
                  aria-hidden="true"
                  style={{ cursor: "pointer" }}
                  onClick={onPrevious}
                ></i>
              </div>
            </div>
            {/* <h4 className="text-primary text-center policyFormTitle premiseFormTitle premiseStepTwoForm PremiseDetailsMainDiv">
              Addresses
            </h4> */}
            <Form
              noValidate
              onSubmit={handleSubmit}
              className="PolicyCreateForm premiseCreateForm premiseAddressForm"
              autoComplete="OFF"
            >
              {/* Address Field */}
              <div style={{ position: "relative", width: "100%" }}></div>

              <div className="col-md-12 mb-4">
                <div className="form-group mb-0" ref={dropdownRef}>
                  <TextField
                    label={
                      <span>
                        Address Line 1{" "}
                        <span style={{ color: "red", marginRight: "5px" }}>
                          *
                        </span>
                      </span>
                    }
                    InputLabelProps={{
                      shrink: true,
                      className: "form-label", // 👈 Add your custom class here
                    }}
                    fullWidth
                    name="address1"
                    id="address1"
                    variant="outlined"
                    value={inputValue || placeData?.address1}
                    onChange={(e) => {
                      setFieldValue("address1", e.target.value);
                      saveToLocalStorage("address1", e.target.value);
                      handleChange(e);
                      handleInputChange(e);
                    }}
                    onFocus={() => {
                      if (suggestions.length > 0) setShowDropdown(true);
                    }}
                    InputProps={{
                      endAdornment: loading && <CircularProgress size={20} />,
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "43px",
                        "& fieldset": {
                          borderColor: "#dee2e6", // default border color
                        },
                        "&:hover fieldset": {
                          borderColor: "#dee2e6", // remove the black border by matching the default color
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#2d64bc", // border color on focus
                          borderWidth: "1px",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "19px",
                        color: "#4a90e2",
                        fontWeight: "600",
                      },
                      "& input": {
                        color: "#444444",
                        fontSize: "0.85rem",
                        fontWeight: "600",
                      },
                    }}
                  />

                  {showDropdown && suggestions.length > 0 && (
                    <Paper
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        maxHeight: 300,
                        overflowY: "auto",
                        marginTop: 4,
                      }}
                    >
                      <List>
                        {suggestions.map((item, index) => (
                          <ListItem
                            key={index}
                            button
                            onClick={() => handleSelect(item)}
                            style={{ padding: "8px 12px" }}
                          >
                            {item.name + "," + " " + item.formatted_address}
                          </ListItem>
                        ))}
                      </List>
                      {nextPageToken && (
                        <div className="loadMoreBtnDiv">
                          <Button
                            className="loadMoreBtn"
                            onClick={handleLoadMore}
                            fullWidth
                          >
                            Load More
                          </Button>
                        </div>
                      )}
                    </Paper>
                  )}

                  {/* <Field
                    type="text"
                    name="address1"
                    id="address1"
                    className="form-input"
                    placeholder=" "
                    autoComplete="off"
                    value={placeData?.address1 || ""}
                    onChange={(e) => {
                      setFieldValue("address1", e.target.value);
                      saveToLocalStorage("address1", e.target.value);
                      handleChange(e);
                    }}
                  /> */}
                </div>
                {(!JSON.parse(localStorage.getItem("stepTwoData"))?.address1 ||
                  JSON.parse(localStorage.getItem("stepTwoData"))?.address1 ===
                    "") && (
                  <span className="text-danger register-error">
                    Address Line 1 is required
                  </span>
                )}
              </div>
              <div className="col-md-12">
                <div className="form-group mb-0">
                  <Field
                    type="text"
                    name="address2"
                    id="address2"
                    className="form-input"
                    placeholder=" "
                    autoComplete="off"
                    value={placeData?.address2 || ""}
                    onChange={(e) => {
                      setFieldValue("address2", e.target.value);
                      saveToLocalStorage("address2", e.target.value);
                      handleChange(e);
                    }}
                  />
                  <label htmlFor="name" className="form-label">
                    Address Line 2
                  </label>
                </div>
                {/* {(!JSON.parse(localStorage.getItem("stepTwoData"))?.address2 ||
                  JSON.parse(localStorage.getItem("stepTwoData"))?.address2 ===
                    "") && (
                  <ErrorMessage
                    name="address2"
                    component="div"
                    className="text-danger register-error premise-address-error"
                  />
                )} */}
              </div>
              <div className="row">
                <div className="col-md-4 mt-4">
                  <div className="form-group mb-0">
                    <Field
                      type="text"
                      name="city"
                      id="city"
                      className="form-input"
                      placeholder=" "
                      autoComplete="off"
                      value={placeData?.city || ""}
                      onChange={(e) => {
                        setFieldValue("city", e.target.value);
                        saveToLocalStorage("city", e.target.value);
                        handleChange(e);
                      }}
                    />
                    <label htmlFor="city" className="form-label">
                      City
                    </label>
                  </div>
                </div>
                {/* <div className="col-md-12 mt-4">
                <div className="form-group mb-0">
                  <Field
                    type="text"
                    name="state"
                    id="state"
                    className="form-input viewOptionField"
                    placeholder=" "
                    readOnly={true}
                    autoComplete="off"
                    value={placeData?.state || ""}
                    onChange={(e) => {
                      setFieldValue("state", e.target.value);
                      saveToLocalStorage("state", e.target.value);
                      handleChange(e);
                    }}
                  />
                  <label htmlFor="state" className="form-label">
                    State <span className="text-danger">*</span>
                  </label>
                </div>
                {showErrors &&
                  (!JSON.parse(localStorage.getItem("stepTwoData"))?.state ||
                    JSON.parse(localStorage.getItem("stepTwoData"))?.state ===
                      "") && (
                    <span className="text-danger register-error">
                      State is required
                    </span>
                  )}
              </div>
              <div className="col-md-12 mt-4">
                <div className="form-group mb-0">
                  <Field
                    type="text"
                    name="country"
                    id="country"
                    className="form-input viewOptionField"
                    placeholder=" "
                    autoComplete="off"
                    readOnly={true}
                    value={placeData?.country || ""}
                    onChange={(e) => {
                      setFieldValue("country", e.target.value);
                      saveToLocalStorage("country", e.target.value);
                      handleChange(e);
                    }}
                  />
                  <label htmlFor="country" className="form-label">
                    Country <span className="text-danger">*</span>
                  </label>
                </div>
                {showErrors &&
                  (!JSON.parse(localStorage.getItem("stepTwoData"))?.country ||
                    JSON.parse(localStorage.getItem("stepTwoData"))?.country ===
                      "") && (
                    <span className="text-danger register-error">
                      Country is required
                    </span>
                  )}
              </div> */}

                <div className="col-md-4 mt-4">
                  <div className="form-group  mb-0">
                    <Field
                      as="select"
                      name="country"
                      id="country"
                      className="form-input"
                      value={
                        JSON.parse(localStorage.getItem("stepTwoData"))
                          ?.country || ""
                      }
                      autoComplete="off"
                      onChange={(e) => {
                        const countryName = e.target.value;
                        console.log("countryName-->", countryName);
                        const country = countries.find(
                          (c) => c.name === countryName
                        );
                        setSelectedCountry(country.isoCode);
                        setSelectedCountryId(country?.isoCode);
                        saveToLocalStorage("country", e.target.value);
                        setFieldValue("country", countryName);
                        const statesByCountry = State.getStatesOfCountry(
                          country.isoCode
                        );
                        setStates(statesByCountry);
                        setSelectedState("");
                        setCities([]);

                        const countryISOCode = country.isoCode;
                        const getPhoneCodeByCountry = (country) => {
                          return phoneCodeFetchByCountry[country] || "+91"; // Default to '+91' if not found
                        };
                        // Example usage
                        const PhoneCodeValue =
                          getPhoneCodeByCountry(countryName);

                        const getDateFormatByCountry = (country) => {
                          return dateFormatFetchByCountry[country] || "d-m-Y"; // Default to 'd-m-Y' if not found
                        };
                        // Example usage
                        const DateFormatValue =
                          getDateFormatByCountry(countryName);

                        const currentData =
                          JSON.parse(localStorage.getItem("stepTwoData")) || {};

                        currentData.phoneCode = PhoneCodeValue;
                        currentData.dateFormat = DateFormatValue;
                        currentData.state = "";
                        currentData.timezone = "";

                        localStorage.setItem(
                          "stepTwoData",
                          JSON.stringify(currentData)
                        );
                      }}
                    >
                      <option value="" selected disabled>
                        Select country
                      </option>
                      {countries.map((country) => (
                        <option key={country.name} value={country.name}>
                          {country.name}
                        </option>
                      ))}
                    </Field>
                    <label htmlFor="country" className="form-label">
                      Country <span className="text-danger">*</span>
                    </label>
                  </div>
                  {showErrors &&
                    (!JSON.parse(localStorage.getItem("stepTwoData"))
                      ?.country ||
                      JSON.parse(localStorage.getItem("stepTwoData"))
                        ?.country === "") && (
                      <span className="text-danger register-error">
                        Country is required
                      </span>
                    )}
                </div>

                <div className="col-md-4 mt-4">
                  <div className="form-group  mb-0">
                    <Field
                      as="select"
                      name="state"
                      id="state"
                      className="form-input"
                      autoComplete="off"
                      value={
                        JSON.parse(localStorage.getItem("stepTwoData"))
                          ?.state || ""
                      }
                      onChange={(e) => {
                        const stateName = e.target.value;
                        setSelectedState(stateName);
                        setFieldValue("state", stateName);
                        saveToLocalStorage("state", stateName);
                        fetchLatLng(stateName);
                      }}
                    >
                      <option value="" selected>
                        Select state
                      </option>
                      {states.map((state) => (
                        <option key={state.name} value={state.name}>
                          {state.name}
                        </option>
                      ))}
                    </Field>
                    <label htmlFor="state" className="form-label">
                      State <span className="text-danger">*</span>
                    </label>
                  </div>
                  {showErrors &&
                    (!JSON.parse(localStorage.getItem("stepTwoData"))?.state ||
                      JSON.parse(localStorage.getItem("stepTwoData"))?.state ===
                        "") && (
                      <span className="text-danger register-error">
                        State is required
                      </span>
                    )}
                </div>
              </div>
              <div className="d-flex justify-content-end mt-4">
                <Button
                  className="previousBtn"
                  variant="light"
                  onClick={onPrevious}
                >
                  Previous
                </Button>
                <Button
                  className="previousBtn premiseNextBtn"
                  type="submit"
                  variant="primary"
                >
                  Next
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      )}
    </Formik>
  );
};

const PremiseThirdStep = ({
  onPrevious,
  onNext,
  timezones,
  premiseData,
  setLoading,
  navigate,
}) => {
  const isSubmittingRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("stepThreeData")) || {};
    // Set default timezone if none is selected
    if (!savedData.timezone && timezones?.length > 0) {
      const defaultTimezone = timezones[0].zoneName;
      const newData = { ...savedData, timezone: defaultTimezone };
      localStorage.setItem("stepThreeData", JSON.stringify(newData));
    }
  }, [timezones]);

  const saveToLocalStorage = (key, value) => {
    const currentData = JSON.parse(localStorage.getItem("stepThreeData")) || {};
    currentData[key] = value;
    localStorage.setItem("stepThreeData", JSON.stringify(currentData));
  };

  const validationSchema = Yup.object({
    timezone: Yup.string().required("Time zone is required"),
  });

  const initialValues = {
    dateFormat: localStorage.getItem("dateFormat") || "",
    timezone: JSON.parse(localStorage.getItem("stepTwoData"))?.timezone,
    kiosk_passcode_enabled:
      JSON.parse(localStorage.getItem("stepThreeData"))
        ?.kiosk_passcode_enabled !== undefined
        ? JSON.parse(localStorage.getItem("stepThreeData"))
            ?.kiosk_passcode_enabled
        : true,
    kiosk_image_capture_enabled:
      JSON.parse(localStorage.getItem("stepThreeData"))
        ?.kiosk_image_capture_enabled !== undefined
        ? JSON.parse(localStorage.getItem("stepThreeData"))
            ?.kiosk_image_capture_enabled
        : true,
  };

  const handlePremiseAction = async (values) => {
    if (isSubmittingRef.current) {
      return;
    }
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setLoading(true);
    try {
      const customerDetails = JSON.parse(
        localStorage.getItem("customerDetails")
      );
      const stepOneData = JSON.parse(localStorage.getItem("stepOneData"));
      const stepTwoData = JSON.parse(localStorage.getItem("stepTwoData"));
      const stepThreeData = JSON.parse(localStorage.getItem("stepThreeData"));
      const authToken = localStorage.getItem("authToken");
      const dateFormatForCountry = localStorage.getItem("dateFormat");
      const countryPhoneCode = localStorage.getItem("countryPhoneCode");

      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      console.log(
        "kiosk_passcode_enabled--->",
        stepThreeData?.kiosk_passcode_enabled
      );

      const payload = {
        title: encryptData(stepOneData?.title),
        name: encryptData(stepOneData?.name),
        address: encryptData(stepTwoData?.address1),
        address2: encryptData(stepTwoData?.address2),
        date_format: encryptData(stepTwoData?.dateFormat),
        country: encryptData(stepTwoData?.country),
        country_code: encryptData(stepTwoData?.phoneCode),
        state: encryptData(stepTwoData?.state),
        city: stepTwoData?.city
          ? encryptData(stepTwoData?.city)
          : encryptData(stepTwoData?.state),
        photo: stepOneData?.photo,
        premise_bt_enabled: encryptData("true"),
        open_time: encryptData(stepOneData?.openTime),
        close_time: encryptData(stepOneData?.closeTime),
        gstNo: encryptData(stepOneData?.gstNo),
        kiosk_passcode_enabled: encryptData(
          stepThreeData?.kiosk_passcode_enabled?.toString()
        ),
        kiosk_image_capture_enabled: encryptData(
          stepThreeData?.kiosk_image_capture_enabled?.toString()
        ),
        customer_account_id: encryptData(
          customerDetails?.customerAccountId?.toString()
        ),
        user_id: encryptData(customerDetails?.userId?.toString()),
        time_zone: encryptData(stepTwoData?.timezone),
        sub_name: encryptData(""),
      };

      const apiUrl = premiseData?.name
        ? `web_api/admin/updatePremise/${premiseData?.premise_id}`
        : "web_api/admin/createPremise";

      console.log("PremisePayload---->", payload);

      const response = await apiRequest(apiUrl, "POST", payload, headers);

      if (response.data?.status === 200) {
        navigate("/premises");
        setLoading(false);
        setTimeout(() => {
          toast.success(
            premiseData?.name
              ? "Premises updated successfully"
              : "Premises created successfully"
          );
        }, 100);
      } else {
        setLoading(false);
        toast.error(response.data?.message || "Request Entity Too Large");
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  const onNexts = (values) => {
    saveToLocalStorage("address1", values.address1);
    saveToLocalStorage("address2", values.address2);
    saveToLocalStorage("country", values.country);
    saveToLocalStorage("state", values.state);
    saveToLocalStorage("city", values.city);
    saveToLocalStorage("kiosk_passcode_enabled", values.kiosk_passcode_enabled);
    saveToLocalStorage(
      "kiosk_image_capture_enabled",
      values.kiosk_image_capture_enabled
    );
    console.log("KioskEnable--->", values.kiosk_passcode_enabled);
    // onNext();
    handlePremiseAction();
  };

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 575);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 575);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => onNexts(values)}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <Card
          className="p-4 premiseDetailsSubDiv"
          style={{
            borderRadius: "10px",
            border: "none",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
          }}
        >
          <Card.Body>
            <div
              className="row"
              style={{ marginTop: "-20px", marginBottom: "-20px" }}
            >
              <div className="col-6">
                <i
                  className="fa fa-long-arrow-left backIcon"
                  aria-hidden="true"
                  style={{ cursor: "pointer" }}
                  onClick={onPrevious}
                ></i>
              </div>
            </div>
            <div className="row userInformationDivConfig generalConfig">
              {!isMobileView && (
                <div className="col-md-3">
                  <div className="p-3 border rounded shadow-sm bg-light informationDetails">
                    <h6
                      className="fw-bold text-primary informationLabel"
                      style={{ fontSize: "15px" }}
                    >
                      General Configuration
                    </h6>
                    <p
                      className=" mb-0 informationDesc"
                      style={{
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "rgb(170, 170, 170)",
                      }}
                    >
                      Select the options. Some of them will be activated based
                      on your license.
                    </p>
                  </div>
                </div>
              )}

              <div className="col-12 col-md-9">
                <Form
                  noValidate
                  onSubmit={handleSubmit}
                  className="userCreateFormConfig premiseCreateForm"
                  autoComplete="OFF"
                >
                  <div className="col-md-12 " style={{ marginBottom: "20px" }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <label
                        htmlFor="name"
                        className="bluetooth-label label-switch mb-0 userFormlabel"
                        style={{ marginLeft: "-13px" }}
                      >
                        Time Zone <span className="text-danger">*</span>
                      </label>

                      <div style={{ width: "200px" }} className="timeZoneDiv">
                        <Field
                          type="text"
                          name="timezone"
                          id="timezone"
                          readOnly={true}
                          className="form-input viewOptionField"
                          placeholder=" "
                          autoComplete="off"
                        />
                        <ErrorMessage
                          name="timezone"
                          component="div"
                          className="text-danger register-error premise-date-error"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-12 configMainDiv"
                    style={{ marginBottom: "30px" }}
                  >
                    <div className="row align-items-center">
                      {/* Label */}
                      <div className="col-md-8 questionOptionDiv premiseConfigOption">
                        <label
                          htmlFor="kiosk_passcode_enabled"
                          className="bluetooth-label label-switch mb-0 configLabel userFormlabel"
                        >
                          If disabled, the user will not be required to enter a
                          passcode for Check In / Out on the Kiosk.{" "}
                        </label>
                      </div>

                      {/* Switch & Labels */}
                      <div className="col-md-4 d-flex align-items-center justify-content-end">
                        <span
                          style={{
                            fontWeight: "bold",
                            color: values.kiosk_passcode_enabled
                              ? "#aaa"
                              : "#f44336",
                            marginRight: "0px",
                          }}
                        >
                          Disable
                        </span>

                        <Switch
                          onColor="#4caf50"
                          offColor="#f44336"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={21}
                          width={40}
                          className="bluetoothSwitch userSwitch switchConfig1"
                          handleDiameter={20}
                          id="kiosk_passcode_enabled"
                          checked={values.kiosk_passcode_enabled}
                          onChange={(checked) => {
                            setFieldValue("kiosk_passcode_enabled", checked);
                            saveToLocalStorage(
                              "kiosk_passcode_enabled",
                              checked
                            );
                          }}
                        />

                        <span
                          style={{
                            fontWeight: "bold",
                            color: values.kiosk_passcode_enabled
                              ? "#4caf50"
                              : "#aaa",
                          }}
                        >
                          Enable
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-md-12 configMainDiv"
                    style={{ marginBottom: "3px", marginTop: "10px" }}
                  >
                    <div className="row align-items-center">
                      {/* Label */}
                      <div className="col-md-8 questionOptionDiv premiseConfigOption">
                        <label
                          htmlFor="kiosk_image_capture_enabled"
                          className="bluetooth-label label-switch mb-0 configLabel userFormlabel"
                        >
                          If disabled, image capture will not be shown to the
                          user during Check In / Out on the Kiosk.{" "}
                        </label>
                      </div>

                      {/* Switch & Labels */}
                      <div className="col-md-4 d-flex align-items-center justify-content-end">
                        <span
                          style={{
                            fontWeight: "bold",
                            color: values.kiosk_image_capture_enabled
                              ? "#aaa"
                              : "#f44336",
                            marginRight: "0px",
                          }}
                        >
                          Disable
                        </span>

                        <Switch
                          onColor="#4caf50"
                          offColor="#f44336"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={21}
                          width={40}
                          className="bluetoothSwitch userSwitch switchConfig1"
                          handleDiameter={20}
                          id="kiosk_image_capture_enabled"
                          checked={values.kiosk_image_capture_enabled}
                          onChange={(checked) => {
                            setFieldValue(
                              "kiosk_image_capture_enabled",
                              checked
                            );
                            saveToLocalStorage(
                              "kiosk_image_capture_enabled",
                              checked
                            );
                          }}
                        />

                        <span
                          style={{
                            fontWeight: "bold",
                            color: values.kiosk_image_capture_enabled
                              ? "#4caf50"
                              : "#aaa",
                          }}
                        >
                          Enable
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      className="previousBtn"
                      variant="light"
                      onClick={onPrevious}
                    >
                      Previous
                    </Button>
                    <Button
                      className="previousBtn premiseNextBtn"
                      type="submit"
                      variant="primary"
                      disabled={isSubmitting}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Card.Body>
        </Card>
      )}
    </Formik>
  );
};

const SaveStep = ({ onPrevious, premiseData, setLoading, navigate }) => {
  const [sensor, setSensor] = useState([]);
  const isSubmittingRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Load data from localStorage on component mount
  useEffect(() => {
    const savedFieldSets =
      JSON.parse(localStorage.getItem("sensorDetails")) || [];
    if (savedFieldSets.length > 0) {
      setSensor(savedFieldSets);
    } else {
      setSensor([
        {
          emitters_device_id: "",
          emitters_device_address: "",
          namespace_id: "",
          instance_id: "",
        },
      ]);
    }
  }, []);

  // Save data to localStorage whenever sensor change
  useEffect(() => {
    localStorage.setItem("sensorDetails", JSON.stringify(sensor));
  }, [sensor]);

  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [currentRowDetails, setCurrentRowDetails] = useState(null);

  const handleShow = (index, fields) => {
    setCurrentIndex(index);
    setCurrentRowDetails(fields);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setCurrentIndex(null);
  };

  const handleConfirm = () => {
    if (currentRowDetails?.emitters_id) {
      const handleEmitterDeleteAPI = async () => {
        try {
          const authToken = localStorage.getItem("authToken");
          const headers = {
            Authorization: `Bearer ${authToken}`,
          };
          const response = await apiRequest(
            `web_api/admin/deletePremiseEmitter/${currentRowDetails?.premise_id}/${currentRowDetails?.emitters_id}`,
            "POST",
            null,
            headers
          );
          if (response.data?.status == 200) {
            // showToast(response.data?.message);
            setLoading(false);
            setTimeout(() => {
              toast.success("Premises emitter deleted successfully");
              // setSubmitting(false);
            }, 100);
          } else {
            setLoading(false);
            toast.error(
              response.data?.message || "An unexpected error occurred."
            );
          }
        } catch (error) {
          setLoading(false);
          toast.error(
            error.response?.data?.message || "Login failed. Please try again."
          ); // Handle specific error messages from API
        } finally {
          setLoading(false);
        }
      };
      handleEmitterDeleteAPI();
    } else {
      setTimeout(() => {
        toast.success("Premises emitter deleted successfully");
        // setSubmitting(false);
      }, 100);
    }
    removeFieldSet(currentIndex);
    handleClose();
  };

  const addNewSensor = () => {
    const newSensor = {
      emitters_device_id: "",
      emitters_device_address: "",
      namespace_id: "",
      instance_id: "",
    };
    setSensor([...sensor, newSensor]);
  };

  const removeFieldSet = (index) => {
    const updatedFieldSets = sensor.filter((_, idx) => idx !== index);
    setSensor(updatedFieldSets);
  };

  const handleFieldChange = (index, field, value) => {
    const updatedFieldSets = [...sensor];
    updatedFieldSets[index][field] = value;
    setSensor(updatedFieldSets);
  };

  const handlePremiseAction = async (values) => {
    if (isSubmittingRef.current) {
      console.warn("SaveStep: duplicate submit ignored");
      return;
    }
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setLoading(true);
    try {
      const customerDetails = JSON.parse(
        localStorage.getItem("customerDetails")
      );
      const stepOneData = JSON.parse(localStorage.getItem("stepOneData"));
      const stepTwoData = JSON.parse(localStorage.getItem("stepTwoData"));
      const stepThreeData = JSON.parse(localStorage.getItem("stepThreeData"));
      const stepFourthData = JSON.parse(localStorage.getItem("stepFourthData"));
      const authToken = localStorage.getItem("authToken");
      const countryPhoneCode = localStorage.getItem("countryPhoneCode");
      const dateFormatForCountry = localStorage.getItem("dateFormat");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const arrayEmitterData =
        JSON.parse(localStorage.getItem("sensorDetails")) || [];

      const filteredArrayEmitterData = arrayEmitterData.filter((obj) =>
        Object.values(obj).some((value) => value !== "")
      );

      const updatedArray = filteredArrayEmitterData.map((obj) => ({
        ...obj,
        namespace_id: "0x00000000000000000001",
        instance_id: "0x000000000001",
      }));

      const payload = {
        title: encryptData(stepOneData?.title),
        name: encryptData(stepOneData?.name),
        address1: encryptData(stepTwoData?.address1),
        date_format: encryptData(dateFormatForCountry),
        country: encryptData(stepTwoData?.country),
        country_code: encryptData(countryPhoneCode?.toString()),
        state: encryptData(stepTwoData?.state),
        city: stepTwoData?.city
          ? encryptData(stepTwoData?.city)
          : encryptData(stepTwoData?.state),
        photo: stepOneData?.photo,
        premise_bt_enabled: encryptData("true"),
        open_time: encryptData(stepOneData?.openTime),
        close_time: encryptData(stepOneData?.closeTime),
        gstNo: encryptData(stepOneData?.gstNo),
        customer_account_id: encryptData(
          customerDetails.customerAccountId.toString()
        ),
        time_zone: encryptData(stepThreeData?.timezone),
        sub_name: encryptData(""),
        emitters_device_id: encryptData(stepFourthData?.emitters_device_id),
        emitters_device_address: encryptData(
          stepFourthData?.emitters_device_address
        ),
        namespace_id: encryptData(stepFourthData?.namespace_id),
        instance_id: encryptData(stepFourthData?.instance_id),
        array_emitter_data: updatedArray,
      };

      if (premiseData?.name) {
        try {
          const response = await apiRequest(
            `web_api/admin/updatePremise/${premiseData?.premise_id}`,
            "POST",
            payload,
            headers
          );

          if (response.data?.status == 200) {
            // showToast(response.data?.message);
            navigate("/premises");
            setLoading(false);
            setTimeout(() => {
              toast.success("Premises updated successfully");
              // setSubmitting(false);
            }, 100);
          } else {
            setLoading(false);
            toast.error(response.data?.message || "Request Entity Too Large");
          }
        } catch (error) {
          setLoading(false);
          toast.error(
            error.response?.data?.message || "Login failed. Please try again."
          ); // Handle specific error messages from API
        } finally {
          setLoading(false);
        }
      } else {
        try {
          const response = await apiRequest(
            "web_api/admin/createPremise",
            "POST",
            payload,
            headers
          );
          if (response.data?.status == 200) {
            // showToast(response.data?.message);
            navigate("/premises");
            setLoading(false);
            setTimeout(() => {
              toast.success("Premises created successfully");
              // setSubmitting(false);
            }, 100);
          } else {
            setLoading(false);
            toast.error(response.data?.message || "Request Entity Too Large.");
          }
        } catch (error) {
          setLoading(false);
          toast.error(
            error.response?.data?.message || "Login failed. Please try again."
          ); // Handle specific error messages from API
        } finally {
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      // Show error message to the user
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{}}
      onSubmit={(values) => {
        // Save to localStorage
        handlePremiseAction(values);
      }}
    >
      {({ handleSubmit }) => (
        <Card
          className="p-4"
          style={{
            borderRadius: "10px",
            border: "none",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
          }}
        >
          <Card.Body>
            <div className="row">
              <div className="col-6">
                <i
                  className="fa fa-long-arrow-left backIcon"
                  aria-hidden="true"
                  style={{ cursor: "pointer" }}
                  onClick={onPrevious}
                ></i>
              </div>
            </div>

            <Form onSubmit={handleSubmit} autoComplete="off">
              <div className="row addNewRuleDiv addNewRowDiv">
                <div className="col-md-4 mb-3">
                  <button
                    type="button"
                    className="btn addNewRuleBtn"
                    onClick={addNewSensor}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i> New
                  </button>
                </div>
              </div>
              <div
                className="scrollable-container emitter-config"
                style={{
                  maxHeight: "400px", // Adjust the height of the scroll area
                  overflowY: "auto",
                  overflowX: "hidden",
                  padding: "10px",
                }}
              >
                {sensor.map((fields, index) => (
                  <Card
                    key={index}
                    className="mb-4"
                    style={{
                      padding: "20px",
                      borderRadius: "8px",
                      position: "relative",
                      border: "none",
                      boxShadow: "1px 2px 8px 2px rgba(0, 0, 0, 0.15)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {index !== 0 && (
                      <div className="col-md-12 deleteRuleDiv deleteItemDiv">
                        <button
                          type="button"
                          className="btn deleteRuleBtn"
                          onClick={() => handleShow(index, fields)}
                          // onClick={() => deleteRule(index)}
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    )}
                    <div className="col-md-10 mt-4">
                      <div className="form-group mb-4 date-picker-wrapper">
                        <Field
                          type="text"
                          name={`emitters_device_id_${index}`}
                          id={`emitters_device_id_${index}`}
                          className="form-input"
                          placeholder=" "
                          autoComplete="off"
                          value={fields.emitters_device_id}
                          onChange={(e) =>
                            handleFieldChange(
                              index,
                              "emitters_device_id",
                              e.target.value
                            )
                          }
                        />
                        <label
                          htmlFor={`emitters_device_id_${index}`}
                          className="form-label"
                        >
                          Sensor Device Id{" "}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-10 mt-1">
                      <div className="form-group mb-4 date-picker-wrapper">
                        <Field
                          type="text"
                          name={`emitters_device_address_${index}`}
                          id={`emitters_device_address_${index}`}
                          className="form-input"
                          placeholder=" "
                          autoComplete="off"
                          value={fields.emitters_device_address}
                          onChange={(e) =>
                            handleFieldChange(
                              index,
                              "emitters_device_address",
                              e.target.value
                            )
                          }
                        />
                        <label
                          htmlFor="emitters_device_address"
                          className="form-label"
                        >
                          Sensor Device Address{" "}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-10 mt-1" style={{ display: "none" }}>
                      <div className="form-group mb-4 date-picker-wrapper">
                        <Field
                          type="text"
                          name={`namespace_id_${index}`}
                          id={`namespace_id_${index}`}
                          className="form-input"
                          placeholder=" "
                          autoComplete="off"
                          value={fields.namespace_id}
                          onChange={(e) =>
                            handleFieldChange(
                              index,
                              "namespace_id",
                              e.target.value
                            )
                          }
                        />
                        <label
                          htmlFor={`namespace_id_${index}`}
                          className="form-label"
                        >
                          Namespace Id
                        </label>
                      </div>
                    </div>
                    <div className="col-md-10 mt-1" style={{ display: "none" }}>
                      <div className="form-group mb-3 date-picker-wrapper">
                        <Field
                          type="text"
                          name={`instance_id_${index}`}
                          id={`instance_id_${index}`}
                          className="form-input"
                          placeholder=" "
                          autoComplete="off"
                          value={fields.instance_id}
                          onChange={(e) =>
                            handleFieldChange(
                              index,
                              "instance_id",
                              e.target.value
                            )
                          }
                        />
                        <label
                          htmlFor={`instance_id_${index}`}
                          className="form-label"
                        >
                          Instance Id
                        </label>
                      </div>
                    </div>
                  </Card>
                ))}
              </div>

              <div className="d-flex justify-content-end mt-4 usersaveForm">
                <Button
                  className="previousBtn"
                  variant="light"
                  onClick={onPrevious}
                >
                  Previous
                </Button>
                <Button
                  className="previousBtn premiseNextBtn"
                  type="submit"
                  variant="primary"
                  disabled={isSubmitting}
                >
                  Save
                </Button>
              </div>
            </Form>
          </Card.Body>
          {showModal && (
            <div
              className="modal show d-block"
              tabIndex="-1"
              role="dialog"
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.5)", // Dimmed background
              }}
            >
              <div className="modal-dialog">
                <div className="modal-content rounded-3 shadow-lg">
                  <div className="modal-header bg-primary deleteMgeHeader text-white">
                    <h5 className="modal-title">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      Confirm Delete
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={handleClose}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body text-center">
                    <p className="text-secondary modal-body-desc">
                      Are you sure you want to delete this item? <br />
                      {/* <strong>This action cannot be undone.</strong> */}
                    </p>
                  </div>
                  <div className="modal-footer d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-secondary px-4 deleteNoBtn"
                      onClick={handleClose}
                      style={{ borderRadius: "8px" }}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger px-4 deleteYesBtn"
                      onClick={handleConfirm}
                      style={{ borderRadius: "8px" }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Card>
      )}
    </Formik>
  );
};

const PremiseAction = () => {
  const location = useLocation();
  const premiseData = location.state?.premise;
  const [currentStep, setCurrentStep] = useState(0);

  const [openTime, setOpenTime] = useState(
    premiseData?.open_time?.slice(0, -3) || "09:30"
  );
  const [closeTime, setCloseTime] = useState(
    premiseData?.close_time?.slice(0, -3) || "19:00"
  );

  const initialValues = {
    title: premiseData?.title || "",
    name: premiseData?.name || "",
    gstNo: premiseData?.gstNo || "",
    subName: premiseData?.sub_name || "",
    address1: premiseData?.address1 || "",
    address2: premiseData?.address2 || "",
    dateFormat: premiseData?.date_format || "",
    country: premiseData?.country || "",
    state: premiseData?.state || "",
    city: premiseData?.city || "",
    premise_bt_enabled:
      premiseData?.premise_bt_enabled === "true" ? true : false,
    openTime: openTime,
    closeTime: closeTime,
    kiosk_passcode_enabled:
      premiseData?.kiosk_passcode_enabled === "true" ? true : false,
    kiosk_image_capture_enabled:
      premiseData?.kiosk_image_capture_enabled === "true" ? true : false,
    photo: "",
    timezone: premiseData?.time_zone || "",
    isEdit: !!premiseData,
  };

  // Validation schema using Yup
  const updateValidationSchema = Yup.object({
    title: Yup.string().required("Type is required"),
    name: Yup.string()
      .trim()
      .required("Name is required")
      .test(
        "unique-premises-name",
        "This premises name is already taken. Please try a different one.",
        function (value) {
          return !isDuplicateUpdatePremisesName(value);
        }
      ),
    address: Yup.string().required("Address is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    timezone: Yup.string().required("Timezone is required"),
    premise_bt_enabled: Yup.boolean().required("Bluetooth is required"),
  });

  const createValidationSchema = Yup.object({
    title: Yup.string().required("Type is required"),
    name: Yup.string()
      .trim()
      .required("Name is required")
      .test(
        "unique-premises-name",
        "This premises name is already taken. Please try a different one.",
        function (value) {
          return !isDuplicatePremisesName(value);
        }
      ),
    address: Yup.string().required("Address is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    timezone: Yup.string().required("Timezone is required"),
    photo: Yup.string().required("Premises Image is required"),
    premise_bt_enabled: Yup.boolean().required("Bluetooth is required"),
  });

  const premisesList = JSON.parse(localStorage.getItem("PremisesList")) || [];
  const isDuplicatePremisesName = (name) => {
    return premisesList.some(
      (premises) => premises.name.toLowerCase() === name.toLowerCase()
    );
  };
  const premisesListDetails = premisesList.filter(
    (premises) => premises.name !== initialValues.name
  );
  const isDuplicateUpdatePremisesName = (name) => {
    return premisesListDetails.some(
      (premises) => premises.name.toLowerCase() === name.toLowerCase()
    );
  };

  const handleNext = () => setCurrentStep((prev) => Math.min(prev + 1, 3));
  const handlePrevious = () => setCurrentStep((prev) => Math.max(prev - 1, 0));

  // const handleFileChange = (event) => {

  // };

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selecetedStates, setSelecetedStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [timezones, setTimezones] = useState([]);

  const timeZoneDetails = (data) => {
    setTimezones(data);
  };

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");

  useEffect(() => {
    // Load all countries
    const allCountries = Country.getAllCountries();
    setCountries(allCountries);
  }, []);

  useEffect(() => {
    if (premiseData?.country) {
      const country = Country.getAllCountries().find(
        (c) => c.name === premiseData.country
      );
      if (country) {
        const fetchedStates = State.getStatesOfCountry(country.isoCode);
        setStates(fetchedStates);
        setSelectedCountry(country.isoCode);

        setTimezones(country ? country.timezones : "");

        if (premiseData.state) {
          const state = fetchedStates.find((s) => s.name === premiseData.state);
          if (state) {
            const fetchedCities = City.getCitiesOfState(
              country.isoCode,
              state.isoCode
            );
            setCities(fetchedCities);
            setSelectedState(state.isoCode);
          }
        }
      }
    }
  }, [premiseData?.country, premiseData?.state]);

  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      setSelectedPremise(selected);
    }
  };

  const [defaultAddress, setDefaultAddress] = useState("");

  useEffect(() => {
    AccessLog(`${premiseData?.title ? "Update" : "Create"} Premises`);
  }, []);

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="contentHeader d-flex align-items-center gap-3 pb-3">
            <div className="contentDiv">
              <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>Premises</Breadcrumb.Item>
                <Breadcrumb.Item active>
                  {premiseData?.title ? "Update" : "Add"}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card shadow premiseAddMainDiv">
                <Container>
                  <Row className="justify-content-center">
                    <Col>
                      {/* Step Progress and Bar at the top */}
                      <StepProgress currentStep={currentStep} />

                      {/* Form steps */}
                      {currentStep === 0 && (
                        <PremiseStepOne
                          onNext={handleNext}
                          setDefaultAddress={setDefaultAddress}
                        />
                      )}
                      {currentStep === 1 && (
                        <PremiseStepTwo
                          onPrevious={handlePrevious}
                          onNext={handleNext}
                          timeZoneDetails={timeZoneDetails}
                          defaultAddress={defaultAddress}
                          setDefaultAddress={setDefaultAddress}
                        />
                      )}
                      {currentStep === 2 && (
                        <PremiseThirdStep
                          onPrevious={handlePrevious}
                          onNext={handleNext}
                          timezones={timezones}
                          premiseData={premiseData}
                          setLoading={setLoading}
                          navigate={navigate}
                        />
                      )}
                      {/* {currentStep === 3 && (
                        <SaveStep
                          onPrevious={handlePrevious}
                          timezones={timezones}
                          premiseData={premiseData}
                          setLoading={setLoading}
                          navigate={navigate}
                        />
                      )} */}
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiseAction;
